module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "epigraph"
    }
  }, [_c('p', {
    staticClass: "epi"
  }, [_c('span', {
    attrs: {
      "aria-label": "vi",
      "epub:type": "pagebreak",
      "id": "page_vi",
      "role": "doc-pagebreak",
      "title": "vi"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "vii",
      "epub:type": "pagebreak",
      "id": "page_vii",
      "role": "doc-pagebreak",
      "title": "vii"
    }
  }, [_vm._v("We’re all stories, in the end. Just make it a good one, eh?")])])]), _vm._v(" "), _c('p', {
    staticClass: "epi-att"
  }, [_vm._v("—The Doctor")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a4fbeac","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781501155475/xhtml/epigraph.vue
// module id = 72
// module chunks = 0